// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4j-5";
export var imageContainer = "_4j-4";
export var metricsGrid = "_4j-2";
export var productDetailContainer = "_4j-1";
export var productListContainer = "_4j-0";
export var subscriberTableContainer = "_4j-3";